import { Card, Grid } from "@mui/material";
import bgImage from "../../Asset/images/bg-sign-in-basic.jpeg";
import MDBox from "../../Components/MDBox";
import MDTypography from "../../Components/MDTypography";
import BasicLayout from "./components/BasicLayout";
import MDInput from "../../Components/MDInput";
import MDButton from "../../Components/MDButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { UserModel } from "../../Api/Models/UserModel";
import { PromiseToaast } from "../../utils/toast/Toast";
import { useDispatch } from "react-redux";
import { isLoignActions } from "../../Context/redux/actions";
import { useNavigate } from "react-router-dom";
import { eraseCookie, setCookie } from "../../utils/tools/CookieManager";

const validationSchema = Yup.object().shape({
  username: Yup.string().required("کد ملی الزامی است"),
  password: Yup.string().required("رمز عبور الزامی است"),
});
export default function LoginComponnent() {
  const [loading, setLoading] = useState<boolean>(false);
  let userModel = new UserModel();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      let formData = new FormData();
      formData.append("grant_type", "password");
      formData.append("username", values.username);
      formData.append("password", values.password);
      let logindata = userModel.Token(formData);
      await PromiseToaast(logindata, {
        error: {
          render({ data }: any) {
            if (data) return data.message;
            return "خطا در برقراری ارتباط";
          },
        },
        pending: "در حال پردازش درخواست",
        success: "ورود موفقیت آمیز بود",
      })
        .then(async (r) => {
          console.log(r.data);
          localStorage.setItem("_t", r.data.access_token);
          localStorage.setItem("_et", r.data.expires_in + Math.round(Date.now() / 1000));

          setCookie("Authorization", r.data.access_token, r.data.expires_in);
          await navigate("/", { replace: true });
          dispatch(isLoignActions(true));
        })
        .catch((e: any) => console.log("با مشکل مواجه شد"));
      await setLoading(false);
    },
  });
  useEffect(() => {
    localStorage.clear();
    eraseCookie("Authorization");
    return () => {};
  }, []);

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            ورود به سامانه
          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}></Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="username"
                name="username"
                onChange={formik.handleChange}
                error={formik.touched.username && Boolean(formik.errors.username)}
                helperText={formik.touched.username && formik.errors.username}
                disabled={loading}
                label="نام کاربری"
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                name="password"
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                label="رمز عبور"
                disabled={loading}
                fullWidth
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}></MDBox>
            <MDBox mt={2} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                ورود
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}
